import script from "./NotifyAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifyAlert.vue?vue&type=script&setup=true&lang=js"

import "./NotifyAlert.vue?vue&type=style&index=0&id=46ef6cfe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ef6cfe"]])

export default __exports__